import React from 'react';
import { Badge } from '@/components/ui/badge';
import { NotificationAlert } from '@/data/notifications';

export const NotificationsBadge = (props: { notifications: NotificationAlert[] }) => {
  return (
    <Badge
      className="rounded-full bg-red-600 text-white w-5 h-5 text-xs absolute left-6 top-[0.8rem] border-2 border-[#2f2f66] flex items-center justify-center"
    >
      {props.notifications?.length}
    </Badge>
  );
};
